/*
 * @format
 * @flow
 */
import React from 'react';
import { Icons } from 'sarsaparilla';

type PropTypes = {
  value: number,
  size: string,
};

export default class CellCoverageIcon extends React.PureComponent<PropTypes> {
  render() {
    const { value, size } = this.props;
    const wholeVal = Math.round(value);
    return <Icons.IconCellService className={`cell-coverage-icon coverage-${wholeVal}`} size={size} />;
  }
}
